import { useState } from 'react';
import { toast } from 'react-toastify';
import { useBlockEditFormStore } from '@ContractBuilder/modules/block-edit';
import { useEntityStore } from '@ContractBuilder/store';
import type { LibraryBlockTypeForListPage } from '@ContractBuilder/types';

import { useBlockCreator } from '../context/context';

export const useLibraryInsert = () => {
  const { handleCancel } = useBlockCreator();
  const { formValues } = useBlockEditFormStore(({ formValues }) => ({ formValues }));
  const { addBlockFromLibrary } = useEntityStore(({ addBlockFromLibrary }) => ({ addBlockFromLibrary }));
  const [isInserting, setIsInserting] = useState(false);

  const onInsertBlock = async (blockLibraryId: string, block: LibraryBlockTypeForListPage | null) => {
    setIsInserting(true);
    const inserted = await addBlockFromLibrary({
      canDelete: block?.canDelete,
      canEdit: block?.canEdit,
      blockLibraryId,
      sectionId: formValues?.section_id ?? '',
      order: (formValues?.order ?? 0) + 1,
    }).catch(() => false);
    setIsInserting(false);

    if (!inserted) {
      toast.error('Failed to add the block from the library. Please try again.');
      return;
    }

    handleCancel();
  };

  return { isInserting, onInsertBlock };
};
